module.exports = __webpack_public_path__ + "img/globulo-quest-blanc.b2ef8cda.png";